<template>
  <div
    :class="
      '_wrapper_gjts0_51 ' +
      [size == 'medium' ? '_md_gjts0_30' : '_sm_gjts0_10'] +
      ' ' +
      [hasError ? '_error_gjts0_105' : hasWarning ? '_alert_gjts0_105' : ''] +
      ' ' +
      [!editable ? '_disabled_gjts0_102' : '']
    "
  >
    <div :class="'_content_gjts0_70'" style="width: calc(100% - 3rem)" @click="clicked()">
      <label v-if="showLabel()">{{ placeholder }}</label>
      <div
        v-if="readonly && showContentSlot && renderedValue"
        :style="
          'display: flex; overflow-x: auto; ' +
          [showLabel() ? 'padding: 1rem 1.25rem; padding-top: 2rem; padding-bottom: 0.5rem' : '']
        "
        class="_input-base_n2fcv_1"
      >
        <slot :name="'content'" />
      </div>
      <input
        :id="'inputTag' + uuid"
        :ref="'input'"
        v-model="renderedValue"
        :disabled="!editable"
        :inputmode="inputmode"
        :placeholder="placeholder"
        :readonly="readonly"
        :style="[
          (readonly && showContentSlot && renderedValue) || showType == 'file'
            ? 'width: 0; height: 0; padding: 0; display: none'
            : ''
        ]"
        :type="showType"
        autocomplete="off"
        class="_input-base_n2fcv_1"
        dir="ltr"
        multiple
        step="any"
        @change="handleFileSelect"
        @focusin="
          () => {
            isFocused = true
            // $emit('update:isFocused', true)
          }
        "
        @focusout="
          () => {
            isFocused = false
            // $emit('update:isFocused', false)
            // $emit('focusOut')
          }
        "
      />
      <Button
        v-if="showType == 'file'"
        :color="'light'"
        :preventDefault="true"
        :size="'small'"
        style="width: 100%; height: 100%;"
        @click="triggerFileInput"
        @drop.prevent="handleDrop"
      >
        <Loading v-if="loading" />
        <p v-else>Upload File</p>
      </Button>
    </div>
    <span
      v-if="clearButton && renderedValue != '' && renderedValue != null"
      class="_suffix_gjts0_21"
    >
      <svg
        class="svg-component"
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        @click=";(renderedValue = null), $refs.input.focus()"
      >
        <path
          d="M7 17L17 7"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        ></path>
        <path
          d="M7.00024 7.00024L17 17"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        ></path>
      </svg>
    </span>
    <span v-else-if="showSlot" class="_suffix_gjts0_21">
      <slot />
    </span>
    <span v-else-if="type == 'phoneNumber'">
      <CountrySelect v-model:reduced="country.dialCode" />
    </span>
    <span v-else-if="asset != ''" class="_suffix_gjts0_21">
      {{ asset }}
    </span>
    <span v-else-if="type == 'password'" class="_suffix_gjts0_21">
      <svg
        v-if="showType == 'password'"
        class="svg-component"
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        @click="showPass()"
      >
        <path
          d="M20.7994 11.2156L21.4575 10.8557L20.7994 11.2156ZM20.7994 12.7846L21.4574 13.1444L20.7994 12.7846ZM3.20058 11.2154L3.8586 11.5753L3.20058 11.2154ZM3.20057 12.7844L2.54254 13.1443H2.54254L3.20057 12.7844ZM19.5236 8.30907C19.227 8.0199 18.7522 8.0259 18.463 8.32247C18.1738 8.61904 18.1798 9.09387 18.4764 9.38304L19.5236 8.30907ZM9.68628 16.9596C9.28505 16.8567 8.87638 17.0986 8.7735 17.4998C8.67062 17.9011 8.91249 18.3097 9.31372 18.4126L9.68628 16.9596ZM14.604 6.34114L14.4099 7.06559L14.604 6.34114ZM7.07264 16.7089L6.70374 17.3619L7.50475 16.0959L7.07264 16.7089ZM3.8586 11.5753C5.43153 8.69919 8.4879 6.75 12 6.75V5.25C7.91882 5.25 4.36847 7.51686 2.54256 10.8556L3.8586 11.5753ZM20.1414 12.4247C18.5685 15.3008 15.5121 17.25 12 17.25V18.75C16.0812 18.75 19.6315 16.4831 21.4574 13.1444L20.1414 12.4247ZM20.1414 11.5754C20.2862 11.8402 20.2862 12.1599 20.1414 12.4247L21.4574 13.1444C21.8475 12.4312 21.8475 11.569 21.4575 10.8557L20.1414 11.5754ZM2.54256 10.8556C2.15249 11.5688 2.15248 12.431 2.54254 13.1443L3.8586 12.4246C3.7138 12.1598 3.7138 11.8401 3.8586 11.5753L2.54256 10.8556ZM18.4764 9.38304C19.1347 10.0249 19.6974 10.7635 20.1414 11.5754L21.4575 10.8557C20.9413 9.91179 20.2876 9.05403 19.5236 8.30907L18.4764 9.38304ZM12 17.25C11.2002 17.25 10.4251 17.1491 9.68628 16.9596L9.31372 18.4126C10.1732 18.633 11.0735 18.75 12 18.75V17.25ZM12 6.75C12.8346 6.75 13.6423 6.85991 14.4099 7.06559L14.7981 5.6167C13.905 5.37739 12.9668 5.25 12 5.25V6.75ZM5.92995 14.9904C5.09529 14.2678 4.39151 13.399 3.8586 12.4246L2.54254 13.1443C3.16202 14.2771 3.97944 15.2858 4.94816 16.1244L5.92995 14.9904ZM7.44154 16.0559C6.90181 15.751 6.3956 15.3935 5.92995 14.9904L4.94816 16.1244C5.48873 16.5924 6.07659 17.0076 6.70374 17.3619L7.44154 16.0559ZM5.00695 16.1704L6.64054 17.3219L7.50475 16.0959L5.87116 14.9444L5.00695 16.1704ZM14.4099 7.06559C15.1269 7.2577 15.8096 7.53359 16.4471 7.88219L17.1668 6.56615C16.426 6.161 15.6321 5.84016 14.7981 5.6167L14.4099 7.06559Z"
          fill="currentColor"
        ></path>
        <path
          d="M19.4644 4.46436L4.46436 19.4644"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        ></path>
        <path
          d="M8.25 12C8.25 12.4142 8.58579 12.75 9 12.75C9.41421 12.75 9.75 12.4142 9.75 12H8.25ZM12 9.75C12.4142 9.75 12.75 9.41421 12.75 9C12.75 8.58579 12.4142 8.25 12 8.25V9.75ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75V8.25C9.92893 8.25 8.25 9.92893 8.25 12H9.75Z"
          fill="currentColor"
        ></path>
      </svg>
      <svg
        v-else
        class="svg-component"
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        @click="hidePass()"
      >
        <path
          d="M3.20057 12.7844C2.93314 12.2954 2.93314 11.7045 3.20058 11.2154C4.9 8.10803 8.20336 6 12 6C15.7966 6 19.1 8.10809 20.7994 11.2156C21.0669 11.7046 21.0669 12.2956 20.7994 12.7846C19.1 15.892 15.7966 18 12 18C8.20336 18 4.89997 15.8919 3.20057 12.7844Z"
          stroke="currentColor"
          stroke-width="1.5"
        ></path>
        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"></circle>
      </svg>
    </span>
  </div>
  <div
    v-if="validations.length > 0 || $slots.hasOwnProperty('bottom')"
    class="_bottom_gjts0_111 items-start"
  >
    <div class="_extra_gjts0_122 d-flex flex-col">
      <FieldValidationDisplay
        v-for="(validation, index) in validations"
        :key="index"
        :ref="'validation_' + index"
        :is-focused="isFocused"
        :label="placeholder"
        :validation-function="validation"
      />
    </div>
    <div class="_extra_gjts0_122">
      <slot name="bottom" />
    </div>
  </div>

  <template v-for="(url_file, _) in url_files" v-if="url_files.size > 0">
    <div class="_card_hl826_1">
      <li class="_description_gm5j8_1">
        <span v-if="url_file[1].name" class="_description-label_gm5j8_10">
          <img
            v-if="$fileUtils.isImage($fileUtils.getExtension(url_file[1].name))"
            :src="url_file[0]"
            alt="Image Preview"
            class="preview-image"
            @click="showViewer.set(url_file[0], true)"
          />
          <span v-else>
            {{ url_file[1].name }}
          </span>
        </span>
        <span class="_description-content_gm5j8_13">
          <Button :preventDefault="true" class="delete-button" @click="deleteFile(url_file[0])">
            <img :src="trashcan" alt="Delete Icon" style="width: 2rem; height: auto" />
          </Button>
        </span>
      </li>
    </div>
    <vue-easy-lightbox
      v-if="showViewer.get(url_file[0])"
      :imgs="[url_file[0]]"
      :visible="showViewer.get(url_file[0])"
      @hide="showViewer.set(url_file[0], false)"
    />
  </template>
</template>

<script>
import FieldValidationDisplay from '../../logic/validations/FieldValidationDisplay.vue'
import Loading from '../Loading.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import trashcan from '../../assets/icons/trashcan.svg'
import Button from '../buttons/AbanButton.vue'
import DateTime from '../datetime/DateTime.vue'
import { fileUtils as $fileUtils } from '../../main'
import { toast } from 'vue3-toastify'

export default {
  name: 'AbanInput',
  computed: {
    $fileUtils() {
      return $fileUtils
    }
  },
  data() {
    return {
      renderedValue: '',
      inputmode: '',
      showType: '',
      hasError: false,
      hasWarning: false,
      isFocused: false,
      country: {
        dialCode: null
      },
      uuid: null,
      loading: 0,
      url_files: new Map(),
      totalUploads: 0,
      completedUploads: 0,
      showViewer: new Map(),
      trashcan: trashcan
    }
  },
  components: {
    DateTime,
    Button,
    VueEasyLightbox,
    FieldValidationDisplay,
    Loading
  },
  props: {
    modelValue: {
      required: false
    },
    type: {
      default: 'numeric'
    },
    inputModeProp: {
      default: ''
    },
    focusOnCreate: {
      default: false
    },
    size: {
      default: 'medium'
    },
    placeholder: {
      default: ''
    },
    asset: {
      default: ''
    },
    showSlot: {
      default: false
    },
    showContentSlot: {
      default: false
    },
    readonly: {
      default: false
    },
    validations: {
      type: Array[Function],
      default: []
    },
    maxDecimalPlaces: {
      default: 18
    },
    maxIntegerPartLength: {
      default: 18
    },
    editable: {
      required: false,
      default: true
    },
    clearButton: {
      default: false
    },
    filePath: {
      type: String,
      required: false
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    instant: {
      type: Boolean,
      default: false
    },
    formatNumeric: {
      type: Boolean,
      default: true,
      required: false
    },
    checkValidation: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  beforeCreate() {
    this.$options.components.CountrySelect = require('../selects/CountrySelect.vue').default
  },
  created() {
    this.uuid = this.$filters.generateUUID()
    this.inputmode = this.inputModeProp
    this.renderValue()
    this.translateShowType()
    this.translateInputMode()
  },
  emits: [
    'update:isFocused',
    'update:modelValue',
    'click',
    // 'focusOut',
    // 'focusIn',
    'file-uploaded',
    'preUpload',
    'no-file'
  ],
  watch: {
    renderedValue: function () {
      this.filter()
      this.unrenderValue()
    },
    modelValue: function () {
      this.renderValue()
    },
    isFocused: function () {
      if (!this.isFocused) this.isValid()
    },
    'country.dialCode': function () {
      if (this.type == 'phoneNumber') this.unrenderValue()
    },
    checkValidation: function () {
      this.isValid()
    },
    url_files: {
      deep: true,
      handler: function () {
        const filesArray = ('file-uploaded', Array.from(this.url_files.values()))
        this.$emit('update:modelValue', filesArray)
      }
    }
  },
  mounted() {
    // if (this.modelValue !== null && this.modelValue !== '') this.isValid()
    setTimeout(() => {
      if (this.focusOnCreate) {
        const inputElement = document.getElementById('inputTag' + this.uuid)
        inputElement.focus()
        inputElement.click()
        inputElement.dispatchEvent(new Event('touchstart', { bubbles: true }))
      }
    }, 100)
    this.$nextTick(() => {
      if (this.$refs.input && this.instant && this.type == 'file') {
        this.triggerFileInput()
      }
    })
  },
  methods: {
    translateShowType() {
      if (this.type == 'password') this.showType = 'password'
      else if (this.type == 'phoneNumber') this.showType = 'numeric'
      else if (this.type == 'file') this.showType = 'file'
      else this.showType = 'text'
    },
    translateInputMode() {
      if (this.inputmode == '') {
        if (this.type == 'numeric') this.inputmode = 'decimal'
        else if (this.type == 'phoneNumber') this.inputmode = 'decimal'
        else this.inputmode = this.type
      }
    },
    filter() {
      if (this.type !== 'decimal' && this.type !== 'numeric' && this.type !== 'phoneNumber') return

      if (this.renderedValue === '' || this.renderedValue === null) return

      this.renderedValue = String(this.renderedValue)
      if (this.type === 'phoneNumber') {
        let dialCode = this.extractDialCodePrefix(this.renderedValue)
        if (dialCode != null) this.country.dialCode = dialCode
        this.renderedValue = this.removeDialCodePrefix(this.renderedValue).replace(/[^\d(+)]/g, '')
        return
      }

      this.renderedValue = this.renderedValue.replace(/[^\d.,-]/g, '')

      if (
        this.$filters.integerPartLength(this.renderedValue) > this.maxIntegerPartLength ||
        this.$filters.decimalPartLength(this.renderedValue) > this.maxDecimalPlaces
      ) {
        this.renderValue()
      }
    },
    _renderValue() {
      if (this.modelValue === undefined) {
        return
      }

      if (this.modelValue === '' || this.modelValue === null) {
        this.renderedValue = this.modelValue
        return
      }

      if (!this.formatNumeric && this.type === 'phoneNumber') {
        this.renderedValue = this.modelValue
        return
      }

      if (this.type === 'text' || this.type === 'password') {
        this.renderedValue = this.modelValue
      } else if (this.type == 'decimal') {
        if (
          this.isPretty(this.renderedValue) &&
          this.unPretty(this.renderedValue) === this.modelValue
        )
          return

        this.renderedValue = this.pretty(
          this.$filters.truncateDecimal(
            this.$filters.numberToString(parseFloat(this.modelValue)),
            this.maxDecimalPlaces
          )
        )
      } else if (this.type === 'numeric') {
        if (
          this.isPretty(this.renderedValue) &&
          this.isNumeric(this.unPretty(this.renderedValue)) &&
          Number(this.unPretty(this.renderedValue)) === this.modelValue
        ) {
          return
        }

        this.renderedValue = this.pretty(
          this.$filters.truncateDecimal(
            this.$filters.numberToString(this.modelValue),
            this.maxDecimalPlaces
          )
        )
      }
    },
    renderValue() {
      this._renderValue()
      this.isValid()
    },
    _unrenderValue() {
      if (this.renderedValue === null) {
        if (this.type != 'phoneNumber') return this.renderedValue
        if (this.country.dialCode == null) return this.renderedValue
        this.renderedValue = ''
      }

      if (this.renderedValue === '' && this.type != 'phoneNumber') {
        if (this.type == 'numeric') return null
        return ''
      }

      if (this.type == 'text' || this.type == 'password') return this.renderedValue
      else if (this.type == 'decimal') {
        if (this.modelValue.indexOf(this.renderedValue) == 0) {
          return this.modelValue
        }

        return this.unPretty(this.renderedValue)
      } else if (this.type == 'numeric') {
        let numericRenderedValue = Number(this.unPretty(this.renderedValue))

        if (this.modelValue == null) {
          return numericRenderedValue
        }

        let truncatedModelValue = this.$filters.truncateDecimal(
          this.$filters.numberToString(this.modelValue),
          this.maxDecimalPlaces
        )

        if (truncatedModelValue == numericRenderedValue) {
          return this.modelValue
        }

        return numericRenderedValue
      } else if (this.type == 'phoneNumber') {
        this.renderPhoneNumber()
        return this.renderedValue
      }
    },
    extractDialCodePrefix(phoneNumberStr) {
      if (phoneNumberStr.includes('(+') && phoneNumberStr.includes(') '))
        return phoneNumberStr.slice(phoneNumberStr.indexOf('(+') + 2, phoneNumberStr.indexOf(') '))
      return null
    },
    removeDialCodePrefix(phoneNumberStr) {
      if (phoneNumberStr.includes(') '))
        return phoneNumberStr.slice(phoneNumberStr.indexOf(') ') + 2)
      if (phoneNumberStr.includes(')')) return phoneNumberStr.slice(phoneNumberStr.indexOf(')') + 1)
      return phoneNumberStr
    },
    renderPhoneNumber() {
      if (this.country.dialCode === null) return
      let prefix = '(+' + this.country.dialCode + ') '
      this.renderedValue = prefix + this.renderedValue.slice(this.renderedValue.indexOf(' ') + 1)
    },
    unrenderValue() {
      let unrenderedValue = this._unrenderValue()
      if (this.type == 'numeric') {
        if (!this.isValueNumber(unrenderedValue)) return
      }

      this.valueChanged(unrenderedValue)
    },
    isValueNumber(value) {
      if (isNaN(value)) return false

      if (value === null) return true
      return typeof value === 'number'
    },
    pretty(number) {
      number = this.$filters.persianToEnglishDigits(number)
      return this.$filters.prettyNumber(number)
    },
    unPretty(text) {
      return text.replaceAll(',', '')
    },
    isPretty(text) {
      if (text == null) return false
      return this.$filters.prettyNumber(this.unPretty(text)) == text
    },
    showPass() {
      this.showType = 'text'
    },
    hidePass() {
      this.showType = 'password'
    },
    clicked() {
      this.focusOnInput()
      this.$emit('click')
    },
    focusOnInput() {
      document.getElementById('inputTag' + this.uuid).focus()
    },
    valueChanged(unrenderedValue) {
      this.$emit('update:modelValue', unrenderedValue)
      this.validate(unrenderedValue)
    },
    getValidationComponent(index) {
      return this.$refs['validation_' + index][0]
    },
    validate(value) {
      if (Object.keys(this.$refs).length == 0) return
      for (var i = 0; i < this.validations.length; i++) this.getValidationComponent(i).clearError()
      if (this.checkValidation == false) return

      let stopped = false
      for (var i = 0; i < this.validations.length; i++) {
        if (stopped && !this.validations[i].showMessage()) continue
        if (
          !this.getValidationComponent(i).isValid(value) &&
          this.validations[i].stopInCaseOfError()
        )
          stopped = true
      }

      this.hasError = this.checkForError()
      this.hasWarning = this.checkForWarning()
    },
    checkForError() {
      for (var i = 0; i < this.validations.length; i++)
        if (!this.validations[i].isWarning() && this.getValidationComponent(i).hasError) return true

      return false
    },
    checkForWarning() {
      for (var i = 0; i < this.validations.length; i++)
        if (this.validations[i].isWarning() && this.getValidationComponent(i).hasError) return true

      return false
    },
    isValid() {
      this.validate(this.modelValue)
      return !this.hasError
    },
    showLabel() {
      return this.size != 'small' && this.renderedValue !== '' && this.renderedValue !== null
    },
    isNumeric(value) {
      return /^-?\d+$/.test(value)
    },
    triggerFileInput() {
      this.$refs.input.click()
    },
    getFileUrls(files) {
      for (const file of files) {
        this.url_files.set(URL.createObjectURL(file), file)
      }
    },
    handleFileSelect(event) {
      if (this.showType != 'file') return
      const files = event.target.files
      if (files) {
        // this.selectedFiles = Array.from(files)
        this.getFileUrls(files)
        if (this.autoUpload) {
          this.uploadFiles()
        } else {
          this.$emit('preUpload')
        }
      }
    },
    handleDrop(event) {
      const files = event.dataTransfer.files // todo: handle this similar to file selection
      if (files) {
        this.getFileUrls(files)
        if (this.autoUpload) {
          this.uploadFiles()
        } else {
          this.$emit('preUpload')
        }
      }
    },
    uploadFiles() {
      if (this.url_files.size === 0) {
        toast.error('Please upload a receipt before creating a deposit')
        return
      }
      for (const [url, file] of this.url_files) {
        this.uploadFile(url, file)
      }
    },
    uploadFile(url, file) {
      this.loading++
      const formData = new FormData()
      formData.append('path', this.filePath)
      formData.append('file', file)
      this.axios
        .post('file/upload', formData)
        .then((response) => {
          const file_path = response.data
          this.url_files.set(url, file_path)
        })
        .catch(() => {})
        .finally(() => {
          URL.revokeObjectURL(url)
          this.loading--
          if (this.loading === 0) {
            this.$emit('file-uploaded', Array.from(this.url_files.values()))
          }
        })
    },
    deleteFile(url) {
      this.url_files.delete(url)
      if (this.url_files.size === 0) this.$emit('no-file')
    }
  }
}
</script>

<style>
.preview-image {
  max-width: 10rem;
  max-height: 5rem;
  width: auto;
  object-fit: contain;
  cursor: pointer;
  display: flex;
  float: left;
}

.delete-button {
  background: none !important;
  border: none !important;
  cursor: pointer !important;
  color: #ff4d4f !important;
  font-size: 1.25rem !important;
  display: flex !important;
  align-items: center !important;
  float: right !important;
  box-shadow: none !important;
}
</style>
